import { v4 as uuid } from 'uuid';

export default {
  props: {
    id: {
      type: String,
      default: null,
    },
    value: {
      type: [String, Boolean, Number, Object, Array, Function],
      default: undefined,
    },
    required: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
    labelPosition: {
      type: String,
      default: 'after',
      validate: (position) => ['before', 'after'].includes(position),
    },
    labelStyle: {
      type: Object,
      default: null,
    },
  },
  computed: {
    hasLabel() {
      return !!this.$slots.default;
    },
  },
  data() {
    return {
      htmlId: this.id !== null
        ? this.id
        : uuid(),
    };
  },
};
